import { useParams } from 'react-router-dom';
import PageMain from '../../components/Navigation/PageMain/PageMain';
import AiCreateEditPromptContainer from '../../components/Settings/Ai/Prompts/AiCreateEditPromptContainer';

export default function AiCreateEditPromptPage() {
    const { promptId } = useParams<{ promptId?: string }>();
    return (
        <PageMain pageTitle="Build Prompt" showError={false} showLoading={false}>
            <div className="settingsPage">
                <div className="settingsPage__wrapper">
                    <AiCreateEditPromptContainer promptId={promptId ? +promptId : 0} />
                </div>
            </div>
        </PageMain>
    );
}
